export const UI_LANGUAGE = {
    'de': 'Deutsch',
    'en': 'English',
    'fr': 'Français',
    'it': 'Italiano'
};

export const ATTACHMENT_TYPE = {
    IMAGE: "8d53bc5a-6d95-4e97-aa25-40c169a3f670",
    DOCUMENT: "64a2202d-0d83-42f4-b945-700bd9b99cce",
};

export const TIMEUNIT_ID = {
    DAY: 'c235f59e-d232-4442-a264-5a5e13f54591',
    DAY2: 'd1cc8f38-3c0c-4112-8072-2de5e58c54a9',
    HALFDAY: '11bc8c97-4bd2-4f36-8aa7-9cab54043de3',
    NIGHT: '524d9afa-c125-440f-b2cb-fd881280ef63',
    HOUR: 'c90fb58d-c51d-4aae-a049-8cb08c25949e',
    WEEK: '70ac7c1f-44ad-4697-8ac5-c808ae930cab',
    MONTH: '117bad75-3651-4e83-9dc3-d7cb8bcfb2bc',
    QUARTER_HOUR: '780ad4c2-b74f-4fde-81e6-5d7710148915',
};

export const TIMEUNIT_ID_TIMES = [TIMEUNIT_ID.QUARTER_HOUR, TIMEUNIT_ID.HOUR];

export const TIMEUNIT_ID_TIMES_MINUTES = [TIMEUNIT_ID.QUARTER_HOUR];

export const ADDRESS_TYPE = {
    POSTAL: "a9108a5f-8c9e-4bc2-8a7b-ee12fba7500c",
    BILLING: "eb690d73-42ad-42d8-a193-90f4d64f2f02",
    DELIVERY: "d4e9ca4f-4c14-4771-a5a4-e0adf28861e1",
};

export const PAYMENT_TYPE = {
    BANKTRANSFER: "72fb5af6-8bdb-47a2-aa19-6d649de40e3e",
    PICKUP: "3a7b3288-8de7-408c-86d1-ac65ff33bafd",
    CREDITCARD: "54bcac28-7d99-4e71-8a9e-bac2bbe7e550",
    PERIODICALINVOICE: "0df9dcb9-ae21-49e8-b7a2-81d6098ad735"
};

export const SERVICE_TYPE = {
    BYRESERVATION: "99d04f60-dff1-4412-b447-214e948aab9b",
    SELECTABLE: "a8431036-b0e8-4a5e-8cc5-5031ddb781cd",
    CONDITIONAL: "92afec83-4ba6-491d-aa65-15c0a858b083",
    OBLIGATORY: "7c111e78-b162-4466-977f-9b49fea69127",
    DESELECTABLE: "9f76edbc-4b0d-4bd8-aaa5-3f85c4959ad1"
};

export const BOOKING_STATUS_TYPE = {
    BOOKED: 'a198f429-6e7d-4a46-b94f-08164c47e1a0',
    CANCELLED: 'cb067253-4185-4749-90c0-139e20ffac5c',
    INTERRUPTED: 'fbfc3b2c-7288-485b-8211-6ab081d7d693'
};